import { render, staticRenderFns } from "./CandidateOnboard.vue?vue&type=template&id=73234439&scoped=true"
import script from "./CandidateOnboard.vue?vue&type=script&lang=js"
export * from "./CandidateOnboard.vue?vue&type=script&lang=js"
import style0 from "./CandidateOnboard.vue?vue&type=style&index=0&id=73234439&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73234439",
  null
  
)

export default component.exports